import * as React from 'react';

import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {PhoneCallIcon} from 'shells/icon/svg/phone-call-icon';
import {TwoLine} from 'shells/two-line/two-line';
import {TwoLineButtonCard} from 'shells/two-line/two-line-button-card';

type Props = {
    phoneNumber: string | null | undefined;
    onClick: () => void;
};

export function PhoneNumberCard(props: Props) {
    return (
        // @ts-expect-error
        <TwoLineButtonCard borderColor={colors.lead} onClick={props.onClick}>
            <TwoLine
                icon={PhoneCallIcon}
                iconSize={24}
                iconColor={colors.grey}
                topRow='Redirect phone number'
                bottomRow={props.phoneNumber}
                isLargeWithSmallBottomRow={true}
                shouldCenterSingleLine={true}
            />
            <div className='color-primary'>{props.phoneNumber ? 'Edit rules' : 'Add rules'}</div>
        </TwoLineButtonCard>
    );
}
